<template>
  <el-dialog
    title="抽取"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    @close="close"
    width="881px"
  >
    <el-form
      :model="extractionForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      :disabled="isReadOnly"
      :label-width="formLabelWidth"
    >
      <el-form-item label="节点名称：">
        <el-input  class="ex-input" v-model="extractionForm.name" show-word-limit maxlength="50">
        </el-input>
        <!-- <div class="setName" @click="setName">智能命名</div> -->
      </el-form-item>
      <el-form-item label="抽取方式：">
        <div class="lineBox">
          <el-radio-group v-model="extractionForm.extractType">
            <el-radio :label="1">按比例抽取</el-radio>
            <el-radio :label="2" :disabled="fixedNumberExtraction"
              >按固定人数抽取</el-radio
            >
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="分组排布：">
        <div class="operate-btn">
          <el-button type="primary" @click="addRatio">添加分组</el-button>
          <el-button v-if="extractionForm.extractType === 1" @click="constrain"
            >等比例分配</el-button
          >
          <el-button class="operate-btn__reset" @click="resetName"
            >重置输出节点名称</el-button
          >
        </div>
        <el-table
          :data="extractionForm.nodeList"
          border
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          max-height="380px"
        >
          <el-table-column
            label="序号"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="拆分人群"
            v-if="extractionForm.extractType === 1"
            :key="extractionForm.extractType"
            width="160"
          >
            <template slot-scope="scope">
              <el-input
                style="width: 100px; margin: 0 10px 0 0"
                v-model="scope.row.percent"
                placeholder="请输入"
              ></el-input>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="拆分人群"
            v-if="extractionForm.extractType === 2"
            :key="extractionForm.extractType"
            width="160"
          >
            <template slot-scope="scope">
              <el-input
                @input.native="checkputn"
                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                style="width: 120px; margin: 0 10px 0 0"
                v-model="scope.row.num"
                placeholder="请输入"
              ></el-input>
              <span>人</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="输出节点名称"
          >
            <template slot-scope="scope">
              <el-input
                class="node-input"
                style="width:100%"
                v-model="scope.row.name"
                maxlength="50"
                show-word-limit
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.$index"
                class="remove-btn"
                @click="removeRatio(scope.$index)"
                type="text"
                >删除</el-button
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button
        type="primary"
        v-loading="loading"
        :disabled="isReadOnly"
        @click="extractionSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "extractionDialog",
  data() {
    return {
      fixedNumberExtraction: true,
      loading: false,
      sumArray: 0,
      formLabelWidth: "auto",
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      extractionForm: {
        name: "",
        extractType: 1,
        nodeList: [],
      },
      parentNodeName:''
    };
  },
  props: {
    // currentLink: null,
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  components: {},
  created() {
    mnode.getNode({ nodeId: this.nodeId }).then((res) => {
      if (res.code === 1 && res.data.name) {
        if(!res.data.isHaveParent){
          this.$message.error('没有源节点，请先连接目标客户人群节点');
        }
        this.extractionForm.name = res.data.name;
        this.parentNodeName = res.data.extractNode.parentNodeName
        if (res.data.extractNode) {
          let listData = [];
          this.fixedNumberExtraction = false;
          this.extractionForm.extractType = res.data.extractNode.rule
            ? res.data.extractNode.rule
            : 1;
          if (
            res.data &&
            res.data.extractNode &&
            res.data.extractNode.rate &&
            res.data.extractNode.rule == 1
          ) {
            listData = res.data.extractNode.rate.split(",") || [];
          }
          if (
            res.data &&
            res.data.extractNode &&
            res.data.extractNode.num &&
            res.data.extractNode.rule == 2
          ) {
            listData = res.data.extractNode.num.split(",") || [];
          }
          const nameData = res.data.extractNode.name?res.data.extractNode.name.split(","):[]
          var nodeListT = [];
          listData.forEach((item, index) => {
            var temp = {
              index: index,
            };
            if (res.data.extractNode.rule == 1) {
              temp.percent = item;
            } else {
              temp.num = item;
            }
            temp.name = nameData[index]?nameData[index]:''
            temp.originName = temp.name
            nodeListT.push(temp);
          });
          if (nodeListT.length > 0) {
            this.extractionForm.nodeList = nodeListT;
          }else{
            const obj = {
              index: 1,
              percent: "0",
              num: "",
              name: "",
              originName: ""
            }
            if(res.data.extractNode.parentNodeName){
              if(res.data.extractNode.parentNodeName.length > 49){
                obj.name = res.data.extractNode.parentNodeName
                obj.originName = obj.name
              }else{
                obj.name = res.data.extractNode.parentNodeName + '1'
                obj.originName = obj.name
              }
            }
            this.extractionForm.nodeList = [obj]
          }
        }
      }
    });
  },
  methods: {
    //智能命名
    setName(){
      mnode.getAutoName(this.nodeId).then(res=>{
        if(res.code==1){
          this.extractionForm.name = res.data
        }else if (res.code == undefined && res.data.code === 0){
          this.$message.warning(res.data.message)
        }
      })
    },
    //只能输入正整数
    checkputn(e) {
      // //  let filtered = e.target.value.replace(/^(0-)|[^\d]/g, "");
      // //  e.target.value = Number(filtered);
      //   // //下边写用户输入时需要的执行逻辑
      //   // if(this.ruleForm.inputprize!= filtered) {
      //   //     this.ruleForm.inputprize = filtered
      //   // }
      //   // 不能输入0，绑定的值如果小于1，那么输入框置空
      // if (e.target.value == "") {
      //    e.target.value = "";
      //    this.$message.error("输入人数不能超过9999999人");
      // }
    },
    close() {
      this.viewVisible = false;
    },
    //删除
    removeRatio(index) {
      this.extractionForm.nodeList.splice(index, 1);
      this.extractionForm.nodeList.forEach((list,index)=>{
        if(list.name == list.originName){
          if(this.parentNodeName){
            if(this.parentNodeName.length > 49){
              list.name = this.parentNodeName
              list.originName = list.name
            }else{
              list.name = this.parentNodeName + (index + 1)
              list.originName = list.name
            }
          }
        }
      })
    },
    //添加分组
    addRatio() {
      const index = this.extractionForm.nodeList.length + 1
      const obj = {
        index,
        percent: 0,
        num: "",
        name: "",
        originName: ""
      }
      if(this.parentNodeName){
        if(this.parentNodeName.length > 49){
          obj.name = this.parentNodeName
          obj.originName = obj.name
        }else{
          obj.name = this.parentNodeName + index
          obj.originName = obj.name
        }
      }
      this.extractionForm.nodeList.push(obj)
    },
    //等比例分配
    constrain() {
      let l = (100 / this.extractionForm.nodeList.length).toFixed(2);
      this.extractionForm.nodeList.forEach((element) => {
        element.percent = l;
      });
    },
    //确定
    extractionSubmit() {
      if (this.loading) {
        return;
      }
      if (this.extractionForm.extractType == "2") {
        let data = JSON.parse(JSON.stringify(this.extractionForm));
        let is = [];
        let every = data.nodeList.every((item, i) => {
          var reg = /^\s*$/g;
          if (reg.test(item.num)) {
            return false;
          } else {
            is.push(i + 1);
            return true;
          }
        });
        if (!every) {
          this.$message.error(`输入框人群数量不能为空!`);
          return false;
        }
      }
      const nameFlag = this.extractionForm.nodeList.every(item=>item.name)
      if(!nameFlag){
        return this.$message.error(`输出节点名称不能为空!`);
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify();
          this.loading = true;
          mnode.updateDetailextract(data).then((res) => {
            this.loading = false;
            if (res.code === 1) {
              // this.viewVisible = false;
              this.$emit("change", {});
              this.$emit("change-name", data);
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    getDataify() {
      let formData = {
        name: "",
        nodeId: "",
      };
      let data = JSON.parse(JSON.stringify(this.extractionForm));
      if (this.extractionForm.extractType == "1") {
        // let sum = 0;
        // data.nodeList.forEach((item) => {
        //   sum += Number(item.percent);
        // });
        // this.sumArray = parseFloat(sum);
        let sum = data.nodeList.reduce((a, b) => {
          return parseFloat(a.percent) + parseFloat(b.percent);
        }, 0);
        if (sum.toFixed(2) > 100) {
          this.$message.error("分组排布累加比例时不能超过100%！");
          return false;
        }
      }
      let rateData = [];
      let numData = [];
      data.nodeList.forEach((item, index) => {
        return rateData.push(item.percent);
      });
      data.nodeList.forEach((item, index) => {
        return numData.push(item.num);
      });
      if (this.extractionForm.extractType === 1) {
        formData.rate = rateData.join(",");
      }
      if (this.extractionForm.extractType === 2) {
        formData.num = numData.join(",");
      } //按比例调整
      formData.rule = this.extractionForm.extractType;
      formData.nodeId = this.$props.nodeId;
      formData.name = this.extractionForm.name;
      formData.childName = data.nodeList.map(item=>item.name).join(",")
      // formData.sourceNodeId = this.currentLink
      // formData.extractNode = JSON.parse(
      //   JSON.stringify(data, (k, v) => {
      //     return k === "name"
      //       ? undefined
      //       : typeof v === "string" && k !== "percent"
      //       ? parseFloat(v)
      //       : v;
      //   })
      // );
      return formData;
    },
    // 重置名称
    resetName(){
      this.extractionForm.nodeList.forEach((item,index)=>{
        if(this.parentNodeName){
          if(this.parentNodeName.length > 49){
            item.name = this.parentNodeName
          }else{
            item.name = this.parentNodeName + (index + 1)
          }
        }else{
          item.name = ""
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.ex-input{
  width: 346px;
  /deep/ .el-input__inner{
    padding-right: 50px
  }
}
.operate-btn{
  margin-bottom: 16px;
  &__reset{
    width: auto;
  }
}
.remove-btn{
  width: auto;
  padding: 0px!important;
}
</style>
